import { useState } from "react";

function useTextField(intitialValue) {
  const [value, setValue] = useState(intitialValue);

  const reset = () => {
    setValue(intitialValue);
  };

  const bind = {
    value,
    onChange: (e) => {
      setValue(e.target.value);
    },
  };

  return [value, bind, reset];
}

export default useTextField;
